import React from "react";
import "../App.css";

export default function About() {
  return (
    <div className="page">
      <h2>Conscious Neurons</h2>

      <p>
        Conscious Neurons LLC is an AI-first software company dedicated to
        creating intelligent systems that don’t just compute — they understand.
        Our mission is to bridge the divide between deep technology and human
        consciousness, building tools that are not only powerful, but profoundly
        attuned to human needs and experience.
      </p>

      <p>
        We specialize in custom neural network development, AI systems
        integration, and full-cycle software production. But more than our
        capabilities, it’s our philosophy that sets us apart. We approach AI not
        as a cold mechanical function, but as an evolving mirror of human
        thought — a companion to cognition rather than a replacement for it.
      </p>

      <p>
        At the core of our work lies a deep respect for consciousness — both
        biological and artificial. We explore architectures that learn, adapt,
        and resonate with the environments they serve. Our team merges technical
        mastery in machine learning, data science, and automation with
        principles rooted in neuroscience, cognitive design, and even spiritual
        clarity.
      </p>

      <p>
        Conscious Neurons believes in building systems that are explainable,
        transparent, and aligned with ethical intent. We challenge the notion of
        "black box" AI, advocating instead for clarity, interpretability, and
        trust.
      </p>

      <p>
        Whether you’re a founder looking to infuse intelligence into your
        platform, a research lab seeking advanced neural modeling, or an
        enterprise ready to automate with meaning — we’re here to architect with
        purpose.
      </p>

      <p>
        Conscious Neurons is more than a company. It's a call to elevate the way
        we think about artificial intelligence — as something that should feel
        natural, amplify awareness, and evolve alongside us in harmony, not
        competition.
      </p>
    </div>
  );
}
